import {
  Flex,
  IconButton,
  IconTrashLine,
  IconUploadLine,
  IconWarningLine,
  Spinner,
  Tooltip,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { ExternalService } from "../../../services/ExternalService";

const Student = ({
  student,
  students,
  setStudents,
  raterData,
  setRaterData,
  resultsMap,
  handleUploadStudentEvidence,
  contextId,
  shareId,
  sortByLastName,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRemoveStudent = (student_id) => {
    setLoading(true);
    ExternalService.removeExternalUserFromOffering(student_id, contextId).then(
      () => {
        setStudents(
          students
            .filter((student) => student.ddl_id !== student_id)
            .sort(sortByLastName)
        );
        let removed = students.find((student) => student.ddl_id === student_id);
        delete raterData[removed.canvas_id];
        setRaterData({ ...raterData });
        window.localStorage.setItem(
          `raterData/${shareId}`,
          JSON.stringify(raterData)
        );
        setLoading(false);
      }
    );
  };

  const handleNameDisplay = (student) => {
    if (student.name) {
      return student.name;
    } else if (student.email) {
      return student.email;
    } else {
      return (
        <Flex gap="xx-small">
          <Flex.Item>{student.canvas_id.toString()}</Flex.Item>
          <Flex.Item margin="0 0 xxx-small 0">
            <Tooltip renderTip={t("rater.noNameOrEmail")}>
              <IconWarningLine color="warning" />
            </Tooltip>
          </Flex.Item>
        </Flex>
      );
    }
  };

  return (
    <Flex alignItems="center" justifyItems="space-between">
      <Flex.Item>{handleNameDisplay(student)}</Flex.Item>
      <Flex.Item>
        <Tooltip color="primary-inverse" renderTip={t("rater.uploadEvidence")}>
          <IconButton
            screenReaderLabel={t("rater.uploadEvidence")}
            renderIcon={IconUploadLine}
            size="small"
            onClick={() => handleUploadStudentEvidence(student)}
          />
        </Tooltip>
        {!resultsMap[student.canvas_id] && (
          <Tooltip color="primary-inverse" renderTip={t("rater.removeStudent")}>
            <IconButton
              screenReaderLabel={t("rater.removeStudent")}
              renderIcon={
                loading ? (
                  <Spinner
                    renderTitle={t("global.pleaseWait")}
                    size="x-small"
                  />
                ) : (
                  IconTrashLine
                )
              }
              disabled={loading}
              size="small"
              margin="0 0 0 small"
              onClick={() => handleRemoveStudent(student.ddl_id)}
            />
          </Tooltip>
        )}
      </Flex.Item>
    </Flex>
  );
};

export default Student;
